/* Cabeçalho compartilhado (index + produto) — menu móvel, scroll e overlay A marca. */
(function () {
  'use strict';

  var cabecalho = document.getElementById('cabecalho');
  if (!cabecalho) return;

  var hamburguer = cabecalho.querySelector('[data-menu-movel]');
  var menuMovel = document.getElementById('menu-movel');
  var ultimoFocoMarca = null;
  var ultimoFocoAjuda = null;

  function fecharMenu() {
    cabecalho.classList.remove('menu-aberto');
    if (hamburguer) hamburguer.setAttribute('aria-expanded', 'false');
  }

  function alternarMenu() {
    var aberto = cabecalho.classList.toggle('menu-aberto');
    if (hamburguer) hamburguer.setAttribute('aria-expanded', String(aberto));
  }

  if (hamburguer) {
    hamburguer.addEventListener('click', function (e) {
      e.preventDefault();
      alternarMenu();
    });
  }

  if (menuMovel) {
    menuMovel.addEventListener('click', function (e) {
      if (e.target.closest('a')) fecharMenu();
    });
  }

  function painelMarca() {
    return document.getElementById('a-marca');
  }

  function fecharAMarca(devolverFoco) {
    var painel = painelMarca();
    if (!painel) return;
    var fechar = document.querySelector('.a-marca__fechar');
    painel.classList.remove('aberto');
    if (fechar) fechar.classList.remove('aberto');
    painel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (devolverFoco && ultimoFocoMarca && ultimoFocoMarca.focus) ultimoFocoMarca.focus();
  }

  function abrirAMarca() {
    var painel = painelMarca();
    if (!painel) return;
    var fechar = document.querySelector('.a-marca__fechar');
    ultimoFocoMarca = document.activeElement;
    fecharMenu();
    requestAnimationFrame(function () {
      painel.classList.add('aberto');
      if (fechar) fechar.classList.add('aberto');
    });
    painel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (fechar) fechar.focus();
  }

  function painelAjuda() {
    return document.getElementById('central-ajuda');
  }

  function protegerCaptchaAjuda(form) {
    if (!form || form.getAttribute('data-captcha-protegido') === 'true') return;
    if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
      window.Shopify.captcha.protect(form);
      form.setAttribute('data-captcha-protegido', 'true');
    }
  }

  function fecharCentralAjuda(devolverFoco) {
    var painel = painelAjuda();
    if (!painel) return;
    var fechar = document.querySelector('.central-ajuda__fechar');
    painel.classList.remove('aberto');
    if (fechar) fechar.classList.remove('aberto');
    painel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (devolverFoco && ultimoFocoAjuda && ultimoFocoAjuda.focus) ultimoFocoAjuda.focus();
  }

  function abrirCentralAjuda() {
    var painel = painelAjuda();
    if (!painel) return;
    var fechar = document.querySelector('.central-ajuda__fechar');
    var formAjuda = document.getElementById('central-ajuda-form');
    protegerCaptchaAjuda(formAjuda);
    ultimoFocoAjuda = document.activeElement;
    fecharMenu();
    fecharAMarca(false);
    requestAnimationFrame(function () {
      painel.classList.add('aberto');
      if (fechar) fechar.classList.add('aberto');
    });
    painel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (fechar) fechar.focus();
  }

  function iniciarFormularioAjudaProduto() {
    if (!window.IMG_PDP) return;
    var form = document.getElementById('central-ajuda-form');
    if (form) {
      form.setAttribute('data-shopify-captcha', 'true');
      protegerCaptchaAjuda(form);
      form.addEventListener('submit', function () {
        var btn = form.querySelector('button[type="submit"]');
        if (!btn || btn.disabled) return;
        try { sessionStorage.setItem('imgoodies_contato_ok', 'ajuda'); } catch (err) { /* ignore */ }
        var enviando = btn.getAttribute('data-rotulo-enviando') || 'Enviando…';
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = enviando;
      });
    }

    var params = new URLSearchParams(window.location.search);
    var flag = '';
    try { flag = sessionStorage.getItem('imgoodies_contato_ok') || ''; } catch (err) { /* ignore */ }
    var hash = (window.location.hash || '').replace('#', '');
    var sucesso = document.querySelector('#central-ajuda .central-ajuda__sucesso');
    if (params.get('contact') === 'ajuda' || flag === 'ajuda' || hash === 'central-ajuda' || sucesso) {
      abrirCentralAjuda();
      if (sucesso && sucesso.focus) sucesso.focus();
      try { sessionStorage.removeItem('imgoodies_contato_ok'); } catch (err) { /* ignore */ }
    }
  }

  document.addEventListener('click', function (e) {
    var alvo = e.target.closest('[data-abrir-a-marca]');
    if (alvo) {
      e.preventDefault();
      fecharCentralAjuda(false);
      abrirAMarca();
      return;
    }
    if (e.target.closest('[data-fechar-a-marca]')) {
      e.preventDefault();
      fecharAMarca(true);
      return;
    }
    alvo = e.target.closest('[data-abrir-central-ajuda]');
    if (alvo) {
      e.preventDefault();
      abrirCentralAjuda();
      return;
    }
    if (e.target.closest('[data-fechar-central-ajuda]')) {
      e.preventDefault();
      fecharCentralAjuda(true);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var ajuda = painelAjuda();
    if (ajuda && ajuda.classList.contains('aberto')) {
      e.preventDefault();
      fecharCentralAjuda(true);
      return;
    }
    if (cabecalho.classList.contains('menu-aberto')) {
      fecharMenu();
      return;
    }
    var painel = painelMarca();
    if (painel && painel.classList.contains('aberto')) {
      e.preventDefault();
      fecharAMarca(true);
    }
  });

  iniciarFormularioAjudaProduto();

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      cabecalho.classList.toggle('encolhido', window.scrollY > 40);
      ticking = false;
    });
  }, { passive: true });
})();
